import React from 'react';
import { LayoutDashboard, Smartphone, BarChart3, Code2 } from 'lucide-react';
import './AdminTabs.css';

export const ADMIN_TABS = [
  { id: 'overview', label: 'Обзор', Icon: LayoutDashboard },
  { id: 'mobile-activity', label: 'Мобильное приложение', Icon: Smartphone },
  { id: 'marketing', label: 'Маркетинг и воронка', Icon: BarChart3 },
  { id: 'noesa-code', label: 'Noesa Code', Icon: Code2 },
];
const currentTab = () => ADMIN_TABS.find((tab) => `#${tab.id}` === window.location.hash)?.id || 'overview';

export function useAdminTabs() {
  const [activeTab, setActiveTab] = React.useState(currentTab);
  const [visited, setVisited] = React.useState(() => ({ [currentTab()]: true }));
  const activate = React.useCallback((id) => {
    setActiveTab(id);
    setVisited((old) => old[id] ? old : { ...old, [id]: true });
  }, []);
  React.useEffect(() => {
    const restore = () => activate(currentTab());
    window.addEventListener('hashchange', restore);
    window.addEventListener('popstate', restore);
    return () => {
      window.removeEventListener('hashchange', restore);
      window.removeEventListener('popstate', restore);
    };
  }, [activate]);
  const selectTab = (id) => {
    if (id === activeTab) return;
    window.history.pushState(window.history.state, '', `${window.location.pathname}${window.location.search}#${id}`);
    activate(id);
  };
  return { activeTab, visited, selectTab };
}

export default function AdminTabs({ activeTab, onSelect }) {
  const refs = React.useRef({});
  function onKeyDown(event, index) {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % ADMIN_TABS.length;
    if (event.key === 'ArrowLeft') next = (index + ADMIN_TABS.length - 1) % ADMIN_TABS.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = ADMIN_TABS.length - 1;
    if (next == null) return;
    event.preventDefault();
    const id = ADMIN_TABS[next].id;
    onSelect(id);
    refs.current[id]?.focus();
  }
  return <div role="tablist" aria-label="Разделы админки" className="admin-tabs">
    {ADMIN_TABS.map(({ id, label, Icon }, index) => <button key={id} type="button" role="tab"
      id={`admin-tab-${id}`} aria-controls={`admin-panel-${id}`} aria-selected={activeTab === id}
      tabIndex={activeTab === id ? 0 : -1} ref={(node) => { refs.current[id] = node; }}
      onClick={() => onSelect(id)} onKeyDown={(event) => onKeyDown(event, index)}>
      <Icon size={18} aria-hidden="true" /><span>{label}</span>
    </button>)}
  </div>;
}

export function AdminTabPanel({ id, activeTab, children }) {
  return <section role="tabpanel" id={`admin-panel-${id}`} aria-labelledby={`admin-tab-${id}`}
    hidden={activeTab !== id} tabIndex={0} className="admin-tab-panel">{children}</section>;
}
